import { render } from "./ProjectEoi.vue?vue&type=template&id=98d74912"
import script from "./ProjectEoi.vue?vue&type=script&lang=js"
export * from "./ProjectEoi.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__